import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Menu as SemanticMenu } from "semantic-ui-react";
import HALogo from "../HALogo";
import "./HNavbar.scss";

export const HNavbar = ({
  homeRoute = "#",
  useRouter = true,
  lighter = false,
  fixed = false,
  logo,
  style = "default",
  className = "",
  ...props
}) => {
  return (
    <SemanticMenu
      secondary
      className={`hireart-ds-navbar 
       ${fixed ? "fixed" : null} 
       ${lighter ? "lighter" : null} 
       ${`hireart-ds-navbar-style-${style} ${className}`}`}
      style={{ minHeight: "64px" }}
    >
      <SemanticMenu.Item
        header
        as={useRouter ? Link : "a"}
        to={homeRoute}
        href={homeRoute}
      >
        {logo ? (
          <img src={logo} alt="HireArt" className="ui logo" />
        ) : (
          <HALogo altLogo={lighter} className="ui logo" />
        )}
      </SemanticMenu.Item>
      {props.children}
    </SemanticMenu>
  );
};

HNavbar.propTypes = {
  fixed: PropTypes.bool,
  homeRoute: PropTypes.string,
  logo: PropTypes.string,
  style: PropTypes.string,
  useRouter: PropTypes.bool,
  lighter: PropTypes.bool,
};

